import generateUtilityClasses from '../../utils/esm/generateUtilityClasses/generateUtilityClasses.esm.js';
import generateUtilityClass from '../../utils/esm/generateUtilityClass/generateUtilityClass.esm.js';

function getListItemIconUtilityClass(slot) {
  return generateUtilityClass('MuiListItemIcon', slot);
}
const listItemIconClasses = generateUtilityClasses('MuiListItemIcon', ['root', 'alignItemsFlexStart']);
var listItemIconClasses$1 = listItemIconClasses;

export { listItemIconClasses$1 as default, getListItemIconUtilityClass };
